import { getEnumValues } from '../enums/get-enum-values';

export enum Group{
	EventAdmins='event-admins',
}

export const GroupValues = getEnumValues<Group>(Group);